<script lang="ts">
	import { ExhibitionsContext } from '#lib/websites/exhibitions/components/ExhibitionsContext/index.js';
	import { ExhibitionsHeader } from '#lib/websites/exhibitions/components/ExhibitionsHeader/index.js';
	interface Props {
		children?: import('svelte').Snippet;
	}

	let { children }: Props = $props();
</script>

<ExhibitionsContext>
	<ExhibitionsHeader>
		{@render children?.()}
	</ExhibitionsHeader>
</ExhibitionsContext>
